var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.firstLogin),callback:function ($$v) {_vm.firstLogin=$$v},expression:"firstLogin"}})}
var staticRenderFns = []

export { render, staticRenderFns }